import { useEffect } from 'react';
import { useProjects } from '/hooks';

export default function Dashboard() {
  const { goTo } = useProjects();
  useEffect(() => goTo('/content?type=article'), []);
  return null;
}
